var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataExportFileIconNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043.35a.746.746 0 1 1 1.056 1.056l-6.72 6.719a.746.746 0 1 1-1.055-1.056L13.043.35z",
    fill: "#67768E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.824 1.625H9.838a.747.747 0 0 1 0-1.493h3.733c.412 0 .747.334.747.746v3.733a.746.746 0 1 1-1.493 0V1.625zM11.33 7.97a.746.746 0 1 1 1.494 0v4.2c0 1.185-.961 2.146-2.146 2.146H2.279a2.146 2.146 0 0 1-2.146-2.147V3.771c0-1.185.96-2.146 2.146-2.146h4.55a.746.746 0 1 1 0 1.493h-4.55a.653.653 0 0 0-.653.653v8.398c0 .361.292.654.653.654h8.399c.36 0 .653-.293.653-.654V7.97z",
    fill: "#67768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExportFileIconNew);
export default __webpack_public_path__ + "static/media/DataExportFileIconNew.1d2b20833aaabba67764766a44fa45fd.svg";
export { ForwardRef as ReactComponent };